import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import { CardTitle } from "../theme/texts";
import useScreenSize from "../../context/ScreenContext";
import WorkoutPerformanceChart from "../charts/WorkoutPerformanceChart";

const PerformanceBarChart = ({
  label,
  dateRangeId,
  type,
  tooltip,
  title,
  subTitle,
}) => {
  const { size, mobileDevice } = useScreenSize();
  let [width] = size;

  return (
    <Box
      width={mobileDevice || width < 650 ? "100%" : "24%"}
      minWidth={"270px"}
    >
      <MainCard>
        <Stack height={"40vh"} minHeight={"300px"} gap={1}>
          <CardTitle
            subTitle={subTitle}
            mainTitle={title}
            isMobile={true}
            alt={true}
          />
          <WorkoutPerformanceChart dateRange={dateRangeId} type={type} />
        </Stack>
      </MainCard>
    </Box>
  );
};

export default PerformanceBarChart;
